export const getStages = async ({ queryKey }) => {
  const [_key] = queryKey;
  let data = await fetch(`${process.env.API_URL}/stages`).then((r) => r.json());
  return data.data;
};
